package com.upcominds.expedite.data.communities

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.model.Community
import com.upcominds.expedite.dto.ActiveCommunitySelectionRequest
import com.upcominds.expedite.dto.CommunityContextDTO
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.ContentType
import io.ktor.http.contentType

class CommunitiesRepositoryImpl: CommunitiesRepository {

    private val httpClient: HttpClient = NetworkClient.httpClient

    // Send userId as a query parameter in the POST. Uses centralized currentUserId when no userId param exists.
    override suspend fun joinCommunity(communityId: String): Community {
        return httpClient.post(NetworkClient.endpoint("api/communities/${communityId}/join")) {
            contentType(ContentType.Application.Json)
        }.body<Community>()
    }

    override suspend fun getJoinedCommunities(): List<Community> {
        return httpClient.get(NetworkClient.endpoint("api/communities/me/joined")).body<List<Community>>()
    }

    override suspend fun getCommunityContext(): CommunityContextDTO {
        return httpClient.get(NetworkClient.endpoint("api/communities/me/context"))
            .body<CommunityContextDTO>()
    }

    override suspend fun setActiveCommunity(communityId: String): CommunityContextDTO {
        return httpClient.put(NetworkClient.endpoint("api/communities/me/active")) {
            contentType(ContentType.Application.Json)
            setBody(ActiveCommunitySelectionRequest(communityId))
        }.body<CommunityContextDTO>()
    }

    override suspend fun getAvailableCommunities(): List<Community> {
        return httpClient.get(NetworkClient.endpoint("api/communities/me/available")).body<List<Community>>()
    }
}
